
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/migrate",
      function () {
        return require("private-next-pages/migrate.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/migrate"])
      });
    }
  